export const buildApiError = async (response, fallback) => {
  if (response.status === 0) {
    const error = new Error("Impossibile connettersi al server");
    error.status = 0;
    return error;
  }

  let payload = null;
  let text = "";

  try {
    payload = await response.json();
  } catch (_) {
    text = await response.text().catch(() => "");
  }

  const message = payload?.error || payload?.message || text || fallback;
  const error = new Error(message);
  error.status = response.status;
  error.code = payload?.code;
  error.details = payload?.details;
  error.payload = payload;
  return error;
};
